import { LOCALE_COOKIE, resolveSupportedLocale, type Locale } from "@/i18n/locales"
import { CLIENT_HOST_HEADER, CLIENT_HOST_WEB, CLIENT_HOST_APP_WEBVIEW, VISIT_ID_HEADER } from "@/platform/api/constants"
import { baseHeaders, PSEUDO_ID_COOKIE, PSEUDO_ID_HEADER } from "@/platform/api/constants"
import { deviceHeaders } from "@/platform/api/device-headers"
import { deviceIdClient } from "@/platform/api/device-id.client"
import type { Identity } from "@/platform/api/identity"
import { visitIdClient } from "@/platform/api/visit-id.client"
import { isAppMode } from "@/platform/app-mode/client"
import { getSessionCookie, getUtmParamSessionCookies } from "@/platform/session/auth/get-session-cookie-client"

// The language the page was actually rendered in, which the root layout stamps onto <html>.
// The cookie can disagree with the URL: a shared /en/… link opens English with no cookie set.
const currentLocale = (): Locale => resolveSupportedLocale(typeof document === "undefined" ? getSessionCookie(LOCALE_COOKIE) : document.documentElement.lang)

export const resolveIdentityClient = (): Identity => {
  const stable: Record<string, string> = {
    ...baseHeaders,
    "Accept-Language": currentLocale(),
    [CLIENT_HOST_HEADER]: isAppMode() ? CLIENT_HOST_APP_WEBVIEW : CLIENT_HOST_WEB,
  }
  if (typeof window !== "undefined") stable["x-device-timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone

  const identifying: Record<string, string> = deviceHeaders(deviceIdClient(), typeof navigator === "undefined" ? null : navigator.userAgent)

  const utmParams = getUtmParamSessionCookies()
  for (const key in utmParams) {
    if (utmParams[key]) identifying[key.replaceAll("_", "-")] = utmParams[key]
  }

  const pseudoId = getSessionCookie(PSEUDO_ID_COOKIE)
  if (pseudoId) identifying[PSEUDO_ID_HEADER] = pseudoId

  // Kept out of `stable`, same reasoning as the server side: a visit is per-visitor, not cache-shared.
  const visitId = visitIdClient()
  if (visitId) identifying[VISIT_ID_HEADER] = visitId

  return { stable, identifying }
}
